import styles from "./Legend.module.scss"
import { Typography } from "src/blitz"
import clsx from "clsx"
import {
  CHART_LEGEND,
  CHART_TIMELINE_LEGEND
} from "src/components/shared/Charts/constant"
import {
  pickLegendClassName,
  pickColorstyleObject
} from "src/components/shared/Charts/Helper/common"
import { useEffect, useMemo, useState } from "react"
import {
  COLOR_TRANSPARENT,
  COLOR_WHITE
} from "src/components/shared/Charts/ExportChart/constants"
import { DOT_SHAPE, NONE } from "src/blitz/Charts/constants"
import { useTranslate } from "src/common/translations"
import store from "src/redux/Store"

const Legend = (props) => {
  const { type = CHART_LEGEND, legend, handleClick, bc = "", isLegendsCollapsed = false, testId = "", isTranslate = false } = props
  const { shape, color, assignedColor, show, name, inputType, disabled = false, xAxis = false } = legend
  const selectedLanguage = store?.getState()?.userData?.selectedLanguage ?? "en"

  const { shapeClassName, colorStyleObject } = useMemo(() => {
    //if (shape === NONE) return {}
    const shapeClassName =
      type === CHART_TIMELINE_LEGEND
        ? styles?.shapeTimeLine
        : pickLegendClassName(shape === NONE ? DOT_SHAPE : shape)
    const colorStyleObject = pickColorstyleObject(type, color || assignedColor)
    return {
      shapeClassName,
      colorStyleObject
    }
  }, [type, color, shape])

  const isBlack = useMemo(
    () => bc === COLOR_WHITE || bc === COLOR_TRANSPARENT,
    [bc]
  )

  const translateFunctions = useTranslate();
  const [legendName, setLegendName] = useState("")
  const equipmentPropertyName = name.split("#$")

  const propertyName = equipmentPropertyName[0] ? equipmentPropertyName[0] : "";
  const separator = (equipmentPropertyName.length >= 2 && equipmentPropertyName[0]) ? ": " : "";
  const equipmentName = equipmentPropertyName[1] ? equipmentPropertyName[1] : ""

  const legendNameTranslate = (translatedText) => {
    return propertyName + separator + translatedText;
  };

  useEffect(() => {
    try {
      const fetchTranslations = async () => {
        const translatedText = equipmentPropertyName[1] ? await translateFunctions(equipmentPropertyName[1]) : "";
        setLegendName(legendNameTranslate(translatedText));
      };

      if (selectedLanguage !== "en") {
        fetchTranslations();
      } else {
        setLegendName(legendNameTranslate(equipmentName));
      }
    }
    catch (e) {
      setLegendName(legendNameTranslate(equipmentName))
    }
  }, [selectedLanguage]);



  return (
    <>
      <div
        className={clsx(styles?.legendItemWrapper, { [styles.legendItemWrapper_collapsed]: isLegendsCollapsed })}
        onClick={() => handleClick && !disabled && handleClick(legend, type)}
      >
        { !xAxis &&
          <span
            className={shapeClassName}
            title={legendName}
            style={{ ...colorStyleObject, opacity: `${show ? 1 : 0.4}` }}
          ></span>
        }
        {inputType !== "radio" ? (
          !isLegendsCollapsed ?
            <Typography
              tagType="span"
              styleType="p4"
              className={clsx("print-txt-color", {
                [styles.reducedOpacity]: !show
              })}
              color={isBlack ? "black" : "default"}
              data-testid={testId}
            >
              {legendName}
            </Typography>
            : <></>
        ) : (
          <>
            <input type="radio" id={name} name={name} value={show} title={name} />
            {!isLegendsCollapsed ?
              <label className={clsx({ [styles.labelBlack]: isBlack })} >
                {name}
              </label> : <></>}
          </>
        )}
      </div>
    </>
  )
}

export default Legend
